import { createAction } from '@reduxjs/toolkit'

export const CHANGE_OPEN_SUPPORT_FORM = '@supportForm/CHANGE_OPEN_SUPPORT_FORM'

export const changeOpenSupportForm = createAction<boolean | undefined>(CHANGE_OPEN_SUPPORT_FORM)
